import _ from "lodash";
import { DashboardEntity } from "../../entity/DashboardEntity";
import { Visualization as VisualizationEntity } from "../../entity/Visualization/Visualization";
import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { DashboardsViewService } from "../../presentation/services/DashboardsView/DashboardsViewService";
import { SourcesService } from "../../presentation/services/SourcesService/SourcesService";
import { MissingParamError } from "../../utils/erros/erros";
import { publicDashboards } from "./Dashbaord.data";

const DashboardCollection = new Mongo.Collection("Dashboards", {
    connection: null
});

export class Dashboard extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDashboard = `${publicSettings.aws.baseUrls.dataTimeseries}/dashboard`;

    constructor({
        Visualization,
        PopulateManager,
        Serie,
        DashboardAvailable
    } = {}) {
        super(DashboardCollection);
        this.Visualization = Visualization;
        this.Serie = Serie;
        this.PopulateManager = PopulateManager;
        this.DashboardAvailable = DashboardAvailable;
    }

    getSeriesInUse(dashboardId, origin = "default") {
        const dashboard = this.findOneCollection({
            _id: { $eq: dashboardId }
        });
        if (!dashboard) return [];
        const seriesIds = [];
        dashboard.sections.forEach((section) => {
            if (origin === "default") {
                section.visualizations.forEach((viz) => {
                    if (viz) {
                        const ids = [
                            ...(Array.isArray(viz.series) ? viz.series : []),
                            viz?.mainSerieId
                        ];
                        if (Array.isArray(viz?.highlightsSeriesIds)) {
                            ids.push(...viz?.highlightsSeriesIds);
                        } else {
                            ids.push(viz?.highlightsSeriesIds);
                        }
                        seriesIds.push(...ids);
                    }
                });
            } else if (origin === "goals") {
                let _golsIds = [];

                section.visualizations.forEach((viz) => {
                    if (viz) {
                        const ids = viz.goals?.map((goal) => goal.r);
                        if (ids?.length) _golsIds.push(...ids);
                    }
                });

                if (dashboard.sources.includes("accounting")) {
                    const ids = this.Serie.findCollection(
                        { referenceId: { $in: _golsIds } },
                        {},
                        "array"
                    ).map((g) => g._id);
                    seriesIds.push(...ids);
                } else {
                    seriesIds.push(..._golsIds);
                }
            }
        });

        return seriesIds.filter((s) => s) || [];
    }

    async getBySources({ companyId, sources }) {
        if (!companyId) return null;
        if (!sources?.length) return null;
        try {
            let {
                result
            } = await this.HttpAdapter.call(
                `${this.baseUrlDashboard}/get-with-visualizations`,
                { companyId, sources }
            );
            return {
                dashboards:
                    result?.dashboards?.map((dashboard) =>
                        DashboardEntity.restore(dashboard)
                    ) || [],
                visualizations:
                    result?.visualizations?.map((visualization) =>
                        VisualizationEntity.restore(visualization)
                    ) || []
            };
        } catch (error) {
            return null;
        }
    }

    /**
     * @public
     * Retorna lista com dashboards e suas respectivas visualizations
     * @param {Object} {companyId}
     * @returns {Boolean}
     */
    async getByCompany({ companyId, source, financialIntegration } = {}) {
        const selectedKey = `${companyId}-${source || "all"}`;
        const managerDashboards =
            this.PopulateManager.findOneCollection({
                collections: { $eq: "dashboards" }
            }) || {};
        const keys = _.get(managerDashboards, "keys") || [];
        let seriesIds = [];
        const sourceService = new SourcesService();
        const sourceQuery = sourceService.getSourceWithSubSourceArray(
            source,
            true
        );
        if (!keys.includes(selectedKey)) {
            try {
                let {
                    result
                } = await this.HttpAdapter.call(
                    `${this.baseUrlDashboard}/get-with-visualizations`,
                    { companyId, sources: sourceQuery }
                );
                this.Visualization.createMany(result?.visualizations);
                if (!result?.dashboards.length) return [];
                if (["nibo", "omie"].includes(financialIntegration?.relation)) {
                    const dashboardFinDefault = result.dashboards.find((d) => {
                        return (
                            d?.metadata?.referenceId ===
                            "04d6b432a7e4ffb9a51c8499"
                        );
                    });
                    if (dashboardFinDefault) {
                        const dashboardFinComparation = angular.copy(
                            dashboardFinDefault
                        );
                        dashboardFinComparation.metadata.activeAllMonths = true;
                        dashboardFinComparation.name = "Previsto x Realizado";
                        dashboardFinComparation.metadata.scenario =
                            financialIntegration.scenario;
                        dashboardFinComparation.name_nd =
                            "PREVISTO X REALIZADO";
                        dashboardFinComparation._id = `${financialIntegration.relation}${dashboardFinComparation._id}`;
                        result.dashboards.push(dashboardFinComparation);
                        this.DashboardAvailable.addId({
                            companyId,
                            source,
                            id: dashboardFinComparation._id
                        });
                    }
                }
                const seriesDependecyDashboard = this._createByCompany(
                    result.dashboards,
                    result.visualizations,
                    {
                        companyId
                    }
                );
                seriesIds.push(...seriesDependecyDashboard);
                this.PopulateManager.modify(
                    { collections: { $eq: "dashboards" } },
                    { $addToSet: { keys: selectedKey } }
                );
            } catch (error) {
                console.error("error", error);
            }
        } else {
            const dashboardsSeriesIds = [];
            const dashboards = this.findCollection(
                {
                    companyId: { $eq: companyId },
                    sources: source
                },
                { fields: { series: 1 } },
                "array"
            );
            dashboards.forEach((dashboard) => {
                dashboardsSeriesIds.push(...dashboard.series);
            });
            seriesIds = dashboardsSeriesIds;
        }
        return seriesIds;
    }

    async getByIds({ _ids, companyId, source }) {
        try {
            let result = [];
            if (_ids.length) {
                const response = await this.HttpAdapter.call(
                    `${this.baseUrlDashboard}/get-with-visualizations`,
                    { ids: _ids }
                );
                result = response.result;
            } else {
                const response = await this.HttpAdapter.call(
                    `${this.baseUrlDashboard}/get-with-visualizations`,
                    { companyId, sources: [source] }
                );
                result = response.result;
            }

            this.Visualization.createMany(result.visualizations);
            if (!result.dashboards.length) return [];
            this._createByCompany(result.dashboards, result.visualizations, {
                companyId,
                sources: source
            });
            return {
                visualizations: result.visualizations,
                dashboards: result.dashboards
            };
        } catch (error) {
            return { visualizations: [], dashboards: [] };
        }
    }
    /**
     * @public
     * @param {Array} data
     * @returns {Boolean}
     */
    _createByCompany = (dashboards = [], visualizations = [], fields = {}) => {
        const total = dashboards.length;
        if (!total) return false;
        visualizations.forEach((visualization) => {
            if (!Array.isArray(visualization.series))
                visualization.series = [];
        });
        const seriesIds = [];
        for (let i = 0; i < total; i++) {
            const dashboard = dashboards[i];
            const visualizationIds = [];
            dashboard.sections.forEach((section) => {
                visualizationIds.push(...section.visualizationsIds);
                section.visualizations = section.visualizationsIds.map(
                    (visualizationId) => {
                        return visualizations.find(
                            (visualization) =>
                                visualization._id == visualizationId
                        );
                    }
                );
            });
            const visualizationDashboard = visualizations.filter(
                (visualization) => {
                    return visualizationIds.includes(visualization._id);
                }
            );
            dashboard.series = [];
            visualizationDashboard.forEach((visualization) => {
                dashboard.series.push(
                    ...visualization.series,
                    _.get(visualization, "highlightsSeriesIds"),
                    _.get(visualization, "mainSerieId")
                );
            });
            dashboard.sources = dashboard.sources;
            dashboard.series = _.without(dashboard.series, undefined);
            seriesIds.push(...dashboard.series);
            this.create({ ...fields, ...dashboard });
        }
        return seriesIds;
    };

    async populateBySource({ companyId, source } = {}) {
        try {
            const {
                result
            } = await this.HttpAdapter.call(
                `${this.baseUrlDashboard}/get-with-visualizations`,
                { companyId, sources: [source] }
            );
            const dashboards = result?.dashboards;
            const visualizations = result?.visualizations;
            this.Visualization.populateBySource({
                companyId,
                source,
                visualizations
            });
            this.deleteMany({
                companyId: { $eq: companyId },
                sources: { $eq: source }
            });
            this.createMany(dashboards);
            return true;
        } catch (error) {
            return false;
        }
    }

    /**
     * @public
     * @param {Array} data
     * @returns {Boolean}
     */
    createMany(data = [], fields = {}) {
        this._before();
        const total = data.length;
        if (!total) return false;
        for (let i = 0; i < total; i++) {
            const document = data[i];
            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();
            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();
            this.create({ ...document, ...fields });
        }
        return true;
    }

    /**
     * @param {Boolean} true caso tenha populado
     */
    async populatePublic(selector) {
        this.deleteMany(selector);
        this.createMany(publicDashboards);
        return true;
    }

    /**
     * @private
     * Monta a coleção para enviar pro banco
     * @param {Array} colletion Array de dashboards
     * @returns {Array} array dos dashboards montado para o banco
     */
    _modelerCollection(collection, companyId) {
        const _modelerSection = (sections) => {
            return _.map(sections, (section) => {
                return {
                    height: section.height,
                    template: section.template,
                    visualizationsIds: section.visualizationsIds
                };
            });
        };

        return _.map(collection, (document, index) => {
            return {
                _id: document._id,
                accounting: document.accounting,
                companiesCount: document.companiesCount || 0,
                companyId: companyId,
                deleted: document.deleted,
                description: document.description || "",
                hidden: document.hidden || false,
                name: document.name,
                name_nd: document.name_nd,
                position: index,
                sections: _modelerSection(document.sections),
                sources: document.sources,
                referenceId: document.referenceId,
                user: document.user,
                version: document.version
            };
        });
    }

    /**
     * @public
     *
     * @param {Object} data
     */
    async upsertMany({
        companyId,
        accountingId,
        collectionDashbaord,
        accounting
    } = {}) {
        collectionDashbaord = this._modelerCollection(
            collectionDashbaord,
            companyId
        );
        if (!companyId) return new MissingParamError("companyId");
        if (!accountingId) return new MissingParamError("accountingId");
        collectionDashbaord = collectionDashbaord.map((dashboard) => {
            dashboard.accounting = accounting;
            dashboard.user = { _id: new UserDataAdapter().user()?._id };
            return dashboard;
        });

        try {
            await this.HttpAdapter.call(`${this.baseUrlDashboard}/save-many`, {
                companyId,
                accountingId,
                dashboards: collectionDashbaord
            });

            this.PopulateManager.deleteMany({
                collections: { $eq: "dashboards" }
            });

            this.deleteMany({ companyId: { $eq: companyId } });

            return true;
        } catch (erro) {
            console.error("error", error);
            return null;
        }
    }

    findDashboardId(companyId, sources) {
        const dashboard = this.findCollection(
            {
                companyId: { $eq: companyId },
                sources: sources,
                $or: [{ hidden: false }, { hidden: { $exists: false } }]
            },
            {
                sort: {
                    position: 1
                },
                fields: {
                    _id: 1
                },
                limit: 1
            },
            "array"
        );

        return _.get(dashboard, "[0]._id");
    }

    async copyPublicDashboards({ companyId, accounting }) {
        const user = new UserDataAdapter().user();

        const response = await this.HttpAdapter.call(
            `${this.baseUrlDashboard}/copy-public`,
            {
                companyId,
                accounting,
                user: {
                    name: user.profile?.name || user.profile?.nickname,
                    _id: user._id
                }
            }
        );
        return response;
    }

    /**
     * @public
     * Realaiza find nos dados locais
     * @param {Object} selector
     * @returns {Object} { list: {Array}, total: {Number} }
     */
    findCollection(selector = {}, options = {}, responseFormat = "object") {
        this._before();
        const dashboardsViewService = new DashboardsViewService();
        const query = { ...selector };
        if (query.sources) {
            query.sources = dashboardsViewService.getDashboardSourcesSelector(
                { sources: query.sources }
            );
        }
        const normalized = this._normalizeSelector(query);
        const list = this.collection.find(normalized, options).fetch();
        if (responseFormat == "array") return list;
        return {
            list,
            total: this.collection.find(normalized).count()
        };
    }
}
